export default __webpack_public_path__ + "static/media/presenters.f91f5e20.svg";